import { useState } from "react";
import { ButtonPrimary } from "./NewButtons";
import { AddFileModal } from "./AddFileModal";
import { FileUploadFormat } from "./forms/inputs/FileUploadInput";

type Props = {
  multipleFiles?: boolean;
  accept?: FileUploadFormat;
  label?: string;
  onSubmit: (files: File[]) => Promise<void>;
};

export const AddFileSelector = (props: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <ButtonPrimary onClick={() => setIsOpen(true)} type="button">
        Upload file
      </ButtonPrimary>
      <AddFileModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        {...props}
      />
    </>
  );
};
